import { CampaignGraphReport } from "../../constants/action-constants/CampaignGraphReportActionConstants";

// Campaign Media Demographic stats
export const getCampaignMediaDemographicStats = (campaignId) => ({
  type: CampaignGraphReport.GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS,
  payload: { campaignId },
});

// campaign graph pdf report
export const downloadCampaignGraphPdfReport = (
  campaignId,
  selectedCityId,
  selectedMetricKey,
  mapCenter,
  mapZoom,
  isSentViaEmail,
  emailIds
) => ({
  type: CampaignGraphReport.DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT,
  payload: {
    campaignId,
    selectedCityId,
    selectedMetricKey,
    mapCenter,
    mapZoom,
    isSentViaEmail,
    emailIds,
  },
});

export const resetCampaignGraphPdfReport = () => ({
  type: CampaignGraphReport.RESET_CAMPAIGN_GRAPH_PDF_REPORT,
});

export const openDownloadCampaignGraphReportForm = () => ({
  type: CampaignGraphReport.OPEN_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL,
});

export const closeDownloadCampaignGraphReportForm = () => ({
  type: CampaignGraphReport.CLOSE_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL,
});

export const openCampaignGraphReportOtherCitiesInfoForm = (processDataObj) => ({
  type: CampaignGraphReport.OPEN_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL,
  payload: { processDataObj },
});

export const closeCampaignGraphReportOtherCitiesInfoForm = () => ({
  type: CampaignGraphReport.CLOSE_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL,
});
